import axios from 'axios';

export default {
    fetchData (params) {
        return axios.get('data/dashboard', { params })
    },
};
